module.exports = __webpack_public_path__ + "img/vip.eeecd29b.png";